import React from 'react';
import { useResponsive } from 'common/context';
import Menu from 'features/dashboard/Menu';
import AddDoc from 'features/dashboard/AddDoc';
import { MenuIDs } from 'features/dashboard/types';

interface ResponsiveBottomNavProps {
  /** Current active menu item */
  menuId: MenuIDs;
  /** Show the Add document button with special styling */
  showAdd?: boolean;
  /** Show the gradient above the menu */
  showGradient?: boolean;
  /** User has active subscription */
  hasSubscribed?: boolean;
}

/**
 * ResponsiveBottomNav - Bottom navigation that hides on desktop web
 *
 * On mobile/native: Shows the bottom navigation bar
 * On desktop web: Hidden (desktop header handles navigation)
 */
export const ResponsiveBottomNav: React.FC<ResponsiveBottomNavProps> = ({
  menuId,
  showAdd = false,
  showGradient = true,
  hasSubscribed = true,
}) => {
  const { shouldExpandForWeb } = useResponsive();

  // Hide on desktop web - top nav handles navigation
  if (shouldExpandForWeb) {
    return null;
  }

  return (
    <>
      {/* Gradient overlay above menu */}
      {showGradient && (
        <div className="doqit-menu-gradient mobile-only" />
      )}

      {/* Bottom spacer */}
      <div
        className="fixed bottom-0 left-0 right-0 mobile-bottom-nav"
        style={{
          width: '100%',
          background: '#F7F5F8',
          height: 15,
          zIndex: 99,
        }}
      />

      {/* Bottom navigation */}
      <div
        className="fixed bottom-0 left-0 right-0 pb-3.5 mobile-bottom-nav"
        style={{ width: '100%' }}
      >
        <div className="menu flex z-0 justify-between rounded-xl menu-wrapper nav-menu m-auto h-[70px]">
          <div className={`half-circle plus-icon plus-icon-position ${showAdd ? ' half-circle-blue' : ''}`}>
            <div className="first-doc-text flex justify-center items-center">
              <div className="w-[220px] h-[56px] text-center absolute b-0">
                <AddDoc showAdd={showAdd} hasSubscribed={hasSubscribed} />
              </div>
            </div>
          </div>
          <Menu menuId={menuId} showGradient={showGradient} />
        </div>
      </div>
    </>
  );
};

export default ResponsiveBottomNav;
